<template>
  <div>
    <div class="row d-flex mb-0">
      <div class="col-11">
        <div class="row align-items-center">
          <div class="col-1">
            <img :src="icon" class="w-30-p rounded"/>
          </div>
          <div class="col-11">
            <div class="row"><span class="col-12">{{title}}</span></div>
            <div v-if="subtitle" class="row"><span class="col-12 text-muted small">{{subtitle}}</span></div>
          </div>
        </div>
        <div v-if="description" class="row mt-3">
          <p class="col-12 mb-0 small text-muted"
             v-html="description"></p>
        </div>
      </div>
      <div class="col-1 d-flex justify-content-end align-self-center align-items-center">
         <icon name="arrow-right"></icon>
      </div>
    </div>
  </div>
</template>

<script>
  import 'vue-awesome/icons/arrow-right'

  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      icon: {
        type: String,
        required: true
      },
      subtitle: String,
      description: String
    }
  }
</script>
